import { fetchCashInPendingVouchers } from '../redux/actions/TransactionActions';
import {
  clientsAbility,
  homeAbility,
  paymentMethodsAbility,
  settlementsHistoryAbility,
  transactionsAbility,
  accountsAbility,
  accountCreateAbility,
  merchantSelfSettingsAbility,
  notesListAbility,
  merchantsAbility,
  supportAbility,
  refundsAbility,
  chargebacksAbility,
  balanceReportListAbility,
  notificationsAbility,
  beneficiariesAbility,
  batchCreationAbility,
  transferAbility,
  topUpAbility,
  upcomingPaymentsAbility,
  authusAbility,
  paymentOrderAbility,
} from '../utils/Capability';
import { Routes as configRouter } from './Routes';


const DASHBOARD = {
  route: configRouter.DASHBOARD,
  icon: 'home',
  text: 'Dashboard',
  capabilities: homeAbility,
};

const TRANSACTIONS = {
  route: configRouter.TRANSACTIONS,
  icon: 'money-bill-wave',
  text: 'Transactions',
  capabilities: transactionsAbility || notesListAbility || refundsAbility || chargebacksAbility || balanceReportListAbility,
  items: [
    {
      route: configRouter.CASH_IN,
      text: 'CashIn',
      capabilities: transactionsAbility.cashInList,
      icon: 'long-arrow-down',
      badge: {
        tooltip: 'tooltipPendingVouchers',
        action: fetchCashInPendingVouchers,
      },
    },
    {
      route: configRouter.RECURRING_PAYMENTS,
      text: 'RecurringPayments',
      capabilities: transactionsAbility.cashOutList,
      icon: 'sync',
    },
    {
      route: configRouter.CASH_OUT,
      text: 'CashOut',
      capabilities: transactionsAbility.cashOutList,
      icon: 'long-arrow-up',
    },
    {
      route: configRouter.UPCOMING_PAYMENTS,
      text: 'UpcomingPayments',
      capabilities: upcomingPaymentsAbility,
      icon: 'money-check',
    },
    {
      route: configRouter.NOTES,
      text: 'Notes',
      capabilities: notesListAbility,
      icon: 'sticky-note',
    },
    {
      route: configRouter.REFUNDS,
      text: 'Refunds',
      capabilities: refundsAbility,
      icon: 'undo',
    },
    {
      route: configRouter.CHARGEBACKS,
      text: 'Chargebacks',
      capabilities: chargebacksAbility,
      icon: 'hand-holding-usd',
    },
    {
      route: configRouter.BALANCE_REPORT,
      text: 'BalanceReport',
      capabilities: balanceReportListAbility,
      icon: 'file-invoice-dollar',
    },
    {
      route: configRouter.BALANCE_REPORT_WALLET,
      text: 'BalanceReportWallet',
      capabilities: balanceReportListAbility,
      icon: 'file-invoice-dollar',
    },
    {
      route: configRouter.WALLET_TRANFER,
      text: 'WalletTranfer',
      capabilities: balanceReportListAbility,
      icon: 'exchange',
    },
  ],
};

const BATCH_CREATION = {
  route: configRouter.BATCH_CREATION,
  icon: 'cloud-upload',
  text: 'BatchCreation',
  capabilities: batchCreationAbility,
  items: [
    {
      route: configRouter.BATCH_CASHOUTS,
      icon: 'long-arrow-up',
      text: 'CashOutBatch',
      capabilities: batchCreationAbility,
    },
  ],
};

const SETTLEMENTS = {
  route: configRouter.SETTLEMENTS,
  icon: 'coins',
  text: 'Settlements',
  capabilities: settlementsHistoryAbility,
};

const KYC = {
  route: configRouter.KYC,
  icon: 'fingerprint',
  text: 'KYCTool',
  capabilities: authusAbility,
};

const TOP_UPS = {
  route: configRouter.TOP_UPS,
  icon: 'comment-dollar',
  text: 'TopUps',
  capabilities: topUpAbility,
};

const TRANSFER = {
  route: configRouter.TRANSFER,
  icon: 'exchange',
  text: 'Transfer',
  capabilities: transferAbility,
};

const COMMERCIAL_RELATIONSHIP = {
  route: configRouter.COMMERCIAL_RELATIONSHIP,
  icon: 'comments-dollar',
  text: 'InternalTransfers',
  capabilities: transferAbility,
};

const CLIENTS = {
  route: configRouter.CLIENTS,
  icon: 'user-chart',
  text: 'Clients',
  capabilities: clientsAbility || beneficiariesAbility,
  items: [
    {
      route: configRouter.CLIENTS,
      icon: 'user-tie',
      text: 'Clients',
      capabilities: clientsAbility,
    },
    {
      route: configRouter.BENEFICIARIES,
      icon: 'user-friends',
      text: 'Beneficiaries',
      capabilities: beneficiariesAbility,
    },
  ],
};

const PAYMENT_METHODS = {
  route: configRouter.PAYMENT_METHODS,
  icon: 'money-check-alt',
  text: 'PaymentMethods',
  capabilities: paymentMethodsAbility,
};

const NOTIFICATIONS = {
  route: configRouter.NOTIFICATIONS,
  icon: 'envelope-open-text',
  text: 'Notifications',
  capabilities: notificationsAbility,
};

const MERCHANTS = {
  route: configRouter.MERCHANTS,
  icon: 'store',
  text: 'Merchants',
  capabilities: merchantsAbility,
  items: [
    {
      route: configRouter.MERCHANTS,
      icon: 'briefcase',
      text: 'InProduction',
      capabilities: merchantsAbility,
    },
    {
      route: configRouter.SIGN_UP_REQUESTS,
      icon: 'layer-plus',
      text: 'SignUpRequests',
      capabilities: merchantsAbility.signUpRequestsList,
    },
  ],
};

const SUBMERCHANTS = {
  route: configRouter.PSP_MERCHANTS,
  icon: 'store-alt',
  text: 'PspMerchants',
  capabilities: merchantsAbility,
};

const ONKEYVERIFY = {
  route: configRouter.ONKEYVERIFY,
  icon: 'check-circle',
  text: 'OneKeyVerify',
  capabilities: accountCreateAbility.accountCreate,
  hide: true,
};

const SETTINGS = {
  route: configRouter.SETTINGS,
  defaultPath: { tabId: 'company' },
  icon: 'cog',
  text: 'Settings',
  capabilities: merchantSelfSettingsAbility,
};

const REFERRED_MERCHANTS = {
  route: configRouter.REFERRED_MERCHANTS,
  icon: 'store',
  text: 'ReferredMerchants',
  capabilities: homeAbility,
};

const SUPPORT = {
  route: configRouter.SUPPORT,
  icon: 'life-ring',
  text: 'Support',
  capabilities: supportAbility,
};

const ACCOUNTS = {
  route: configRouter.ACCOUNTS,
  icon: 'users',
  text: 'Accounts',
  capabilities: accountsAbility || accountCreateAbility,
  items: [
    {
      route: configRouter.ACCOUNTS,
      text: 'Users',
      capabilities: accountsAbility,
      icon: 'user-edit',
    },
    {
      route: configRouter.ACCOUNT_PRESETS,
      text: 'Presets',
      capabilities: accountCreateAbility.accountCreate,
      icon: 'user-lock',
    },
  ],
};

const FAQs = {
  route: configRouter.FAQS,
  icon: 'question',
  text: 'FAQs',
  capabilities: accountCreateAbility.accountCreate,
};

const PAYMENT_ORDERS_GROUP = {
  icon: 'envelope-open-dollar',
  text: 'TuRecaudo',
  capabilities: paymentOrderAbility,
  items: [
    {
      route: configRouter.PAYMENT_ORDERS_BATCHES,
      text: 'PaymentOrderBatch',
      icon: 'folder-upload',
      capabilities: paymentOrderAbility,
    },
    {
      route: configRouter.PAYMENT_ORDERS,
      text: 'PaymentOrders',
      icon: 'envelope-open-dollar',
      capabilities: paymentOrderAbility,
    },

  ],
};

const commonNavItems = [DASHBOARD, TRANSACTIONS, SETTLEMENTS, TOP_UPS, CLIENTS, PAYMENT_METHODS, MERCHANTS, SUBMERCHANTS, ONKEYVERIFY, SETTINGS, SUPPORT, ACCOUNTS, FAQs];

const allNavItems = [
  ...commonNavItems,
  BATCH_CREATION,
  KYC,
  COMMERCIAL_RELATIONSHIP,
  TRANSFER,
  NOTIFICATIONS,
  REFERRED_MERCHANTS,
];

const tupayNavItems = [
  DASHBOARD,
  TRANSACTIONS,
  PAYMENT_ORDERS_GROUP,
  SETTLEMENTS,
  TOP_UPS,
  CLIENTS,
  PAYMENT_METHODS,
  MERCHANTS,
  ONKEYVERIFY,
  SETTINGS,
  SUPPORT,
  ACCOUNTS,
  FAQs,
];

const panelSpecificNavItems = {
  DIRECTA: allNavItems,
  LIMEPAY: allNavItems,
  ONEKEY_PAYMENTS: allNavItems,
  POVILE: allNavItems,
  TUPAY: tupayNavItems,
};

export const getNavbarConfig = (panelType) => {
  return panelSpecificNavItems[panelType] || [...commonNavItems];
};

export default getNavbarConfig;
